import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BreadcrumbService} from '../../services/breadcrumb.service';
import {NotificationService} from '../../services/notification.service';
import {BreadcrumbClientDTO} from '../../model/breadcrumbClientDTO';
import {BreadcrumbAccountDTO} from '../../model/breadcrumbAccountDTO';
import {BreadcrumbReportDTO} from '../../model/breadcrumbReportDTO';
import {ReportService} from '../../services/report.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  clients: Array<BreadcrumbClientDTO> = [];
  accounts: Array<BreadcrumbAccountDTO>;
  reports: Array<BreadcrumbReportDTO>;
  activeClient: BreadcrumbClientDTO;
  activeAccount: BreadcrumbAccountDTO;
  activeReport: BreadcrumbReportDTO;

  @Input() currentPage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    public reportService: ReportService,
    private service: BreadcrumbService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => this.update(params));
  }

  update(routeParams) {
    const params = {...routeParams};
    if (params.reportType) {
      params.reportType = ReportService.getReportTypeFromUrl(params.reportType);
    }
    this.service.getBreadcrumb(params).subscribe(res => {
      this.clients = res.clients;
      this.activeClient = this.clients.filter(client => client.active)[0];
      if (this.activeClient) {
        this.accounts = this.activeClient.accounts;
        if (this.accounts) {
          this.activeAccount = this.accounts.filter(account => account.active)[0];
        }
        this.reports = this.activeClient.reports;
        if (this.reports) {
          this.activeReport = this.reports.filter(report => report.active)[0];
        }
      }
    });
  }

  toReport(report) {
    this.router.navigate(this.reportService.getReportUrl(this.activeClient.id, report.code, report.year));
  }
}
